import { render, staticRenderFns } from "./group_message_sender_tbn.vue?vue&type=template&id=02b5d5f1&"
import script from "./group_message_sender_tbn.vue?vue&type=script&lang=js&"
export * from "./group_message_sender_tbn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports